import BillDetails from '../pages/Cart/BillDetails';

export const restaurantDetails = {
  title: 'Embers Restaurant',
  category: 'Breakfast',
  rating: 4,
  ratingCount: 11,
  openingTime: '11.00 AM',
  closingTime: '8.00 PM',
  distance: '1.8 mile',
  address: '1122 CA-41, Fish Camp, CA, Australia, Opera house, 55411',
  categoryItem: ['Snack', 'Continental', 'Tandori'],
  image:
    'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=720&q=80',
};

export const specialList = [
  { id: 1, name: 'Snack' },
  { id: 2, name: 'Breakfast' },
  { id: 3, name: 'Recommended' },
  { id: 4, name: 'Exclusive' },
  { id: 5, name: 'Cafe' },
  { id: 6, name: 'Chinese' },
];

export const specialFoodItems = [
  {
    id: 's1',
    image:
      'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/ytkpjvllqsew1wtaezsu',
    foodName: 'Chicken Cheese Burger',
    foodCategory: 'Non Veg',
    power: '500 Cal',
    price: 30.0,
    quantity: 1,
  },
  {
    id: 's2',
    image:
      'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/ezlyspar4r6gsoov6q6q',
    foodName: 'Loaf Omlette',
    foodCategory: 'Veg',
    power: '200 Cal',
    price: 20.0,
    quantity: 1,
  },
  {
    id: 's3',
    image:
      'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/lh2lyuhcvapx0jb7zjcp',
    foodName: 'Cottage Cheese with Basil Noodles',
    foodCategory: 'Non Alergic',
    power: '150 Cal',
    price: 25.0,
    quantity: 1,
  },
  {
    id: 's4',
    image:
      'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/cdzju71tjrbyg5d8ifel',
    foodName: 'Chicken Sauce Burger',
    foodCategory: 'Non Veg',
    power: '450 Cal',
    price: 45.0,
    quantity: 1,
  },
];

// color code is comparing between value of enum foodCategoryType
export const foodCategoryColor = [
  '#43B61A',
  '#5BC2B6',
  '#FF1111',
  '#FAC214',
  // "#5BC2B6",
  // "#FF1111",
  // "#43B61A",
];

export const itemDetails = {
  id: 's1',
  description:
    'A sandwich consisting of a patty made from ground chicken, served in a bun, typically hot and often with other ingredients.',
  extraItems: [
    {
      item: 'Double Quarter Pounder with Cheese Meal [Large]',
      unitPrice: 5,
      quantity: 1,
      data: [
        { id: 0, value: 'Apple' },
        { id: 1, value: 'Coconut' },
        { id: 2, value: 'Banana shake' },
        { id: 3, value: 'Banana1' },
        { id: 4, value: 'Banana2' },
      ],
    },
    {
      item: 'Single Quarter Pounder with Cheese Meal [Large]',
      unitPrice: 5,
      quantity: 3,
      data: [
        { id: 0, value: 'Lichi' },
        { id: 1, value: 'Coconut' },
        { id: 2, value: 'Banana shake' },
        { id: 3, value: 'Banana1' },
        { id: 4, value: 'Banana2' },
      ],
    },
    {
      item: 'Sizzle',
      unitPrice: 2,
      quantity: 2,
      data: [
        { id: 0, value: 2 },
        { id: 1, value: 4 },
        { id: 2, value: 6 },
        { id: 3, value: 5 },
        { id: 4, value: 1 },
      ],
    },
    {
      item: 'Side',
      unitPrice: 3,
      quantity: 4,
      data: [
        { id: 0, value: 'Mutton' },
        { id: 1, value: 'Chicken' },
        { id: 2, value: 'Fish' },
        { id: 3, value: 'Veg' },
      ],
    },
  ],
};

export const getReceiptDetails = [
  {
    orderId: '4512',
    itemSubTotal: 100,
    discount: 0,
    serviceCharge: 10,
    servedBy: {
      restaurantsName: 'Food Corner',
      address: '3001 Mannheim Rd, Franklin Park, IL 60131',
      contact: '1 675 896 8976',
      orderPlacedDate: 'Feb 23, 2023',
      orderPlacedTime: '3:40 PM',
    },
    orderedBy: {
      userName: 'Manoel Tamraz',
      userRole: 'Customer',
      userEmail: 'manoel@gmail.com',
      userContact: '1 675 435 7575',
      pickupDate: 'Feb 23, 2023',
      pickupTime: '4:20 PM',
    },
    billDetails: [
      {
        id: 1,
        name: 'Chicken Cheese Burger',
        quantity: 2,
        price: 60,
      },
      {
        id: 2,
        name: 'Double Quarter Pounder with Cheese Meal',
        quantity: 2,
        price: 10,
      },
      {
        id: 3,
        name: 'Sizzle',
        quantity: 1,
        price: 5,
      },
      {
        id: 4,
        name: 'Side',
        quantity: 2,
        price: 4,
      },
      {
        id: 5,
        name: 'Loaf Omletted',
        quantity: 1,
        price: 15,
      },
      {
        id: 6,
        name: 'Side',
        quantity: 3,
        price: 6,
      },
    ],
  },
];

export const orderDetailsData = [
  {
    orderId: '4512',
    orderStatus: 2,
    userName: 'Manoel Tamraz',
    orderPaymentStatus: true,
    paymentDate: 'Feb 23, 2023',
    paymentTime: '3:40 PM',
    orderItems: [
      {
        itemName: 'Chicken Cheese Burger',
        itemQuantity: 2,
        addOns: [
          {
            id: 1,
            name: 'Double Quarter Pounder with Cheese Meal [Large]',
          },
          {
            id: 2,
            name: 'Single Quarter Pounder with Cheese Meal [Large]',
          },
          {
            id: 3,
            name: 'Sizzle',
          },
        ],
      },
      {
        itemName: 'Loaf Omlette',
        itemQuantity: 1,
        addOns: [
          {
            id: 4,
            name: 'Double bread [Large]',
          },
          {
            id: 5,
            name: 'Single cheese [Large]',
          },
          {
            id: 3,
            name: 'Sizzle',
          },
        ],
      },
    ],
  },
];
